import { useState, useEffect } from "react";
import { sendMessage } from "../../wsFunctions/socket";

function TimeoutedUser(props) {
    const { user, changeCooldown } = props;
    const [time, setTime] = useState(Math.ceil((user.until - Date.now()) / 1000 / 60));

    useEffect(() => {
        const timerUpdate = setInterval(() => {
            setTime(() => (Math.ceil((user.until - Date.now()) / 1000 / 60)));
            if (time <= 0) {
                sendMessage({ type: "timeout-users-delete", data: { userID: user.userID }});
            };
        }, 500);

        return () => clearInterval(timerUpdate)
    }, [user]);

    const [value, setValue] = useState("");

    return (
        <div className="deactiveated-list-item">
            <p><b>ID: </b> {user.userID}</p>
            <div>
                <p>Minutter ({time})</p>
                <input placeholder="Tom fjerner timeout" onChange={(e) => { setValue(e.target.value) }} value={value} type="number" inputMode="numeric" />
                <button className="change-btn" data-id={user.userID} onClick={() => { changeCooldown(user.userID, value); setValue("") }}>Endre timeout</button>
            </div>
        </div>
    );
};

export default TimeoutedUser;